module.exports = __webpack_public_path__ + "static/media/chart.6f43e916.png";